import styled from "styled-components";
import { colors } from "../../styles/tokens";

export const ContainerForm = styled.form`
  > div {
    display: flex;
    flex-direction: column;

    gap: 32px;

    > div {
      display: flex;
      align-items: center;
      gap: 20px;

      width: 100%;



      @media (max-width: 767px) {
        flex-wrap: wrap;
      }

      > div {
        width: 100%;
      }
    }
  }
`;

export const ContainerHoursOfOperation = styled.div`
  display: flex;
  flex-direction: column;

  gap: 6px;

  label {
    color: rgb(255, 255, 255);

    padding: 0px 16px;
    font-size: 14px;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 20px;

    > div:nth-child(1) {
      padding: 4px 16px;
    }
  }
`;

export const ContainerAddress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5vw;

  > label {
    color: rgb(255, 255, 255);
    font-weight: bold;

    padding: 0px 16px;
  }
`;

export const ContainerHeader = styled.div`
  align-items: center;
  display: flex;

  gap: 2.5vw;

  margin-bottom: 47px;

  > h1 {
    color: #fff;
    font-size: 2rem;
    font-weight: 700;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  align-items: start;

  gap: 20px;

  height: auto;

  margin-top: 20px;

  > button {
    background: linear-gradient(135deg, ${colors.gradientStart} 0%, ${colors.brand} 55%, ${colors.gradientEnd} 100%);
    background-size: 180% 180%;
    align-items: center;
    border: none;
    border-radius: 100px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    max-width: 245px;
    padding: 16px 26px;
    font-size: 15px;
    font-weight: 600;
    transition: transform 180ms ease, background-position 400ms cubic-bezier(0.2, 0.8, 0.2, 1);

    &:hover { transform: translateY(-1px); background-position: 100% 50%; }

    color: #fff;

    gap: 10px;
  }
`;

export const ContainerImages = styled.div`
  max-width: 100%;

  > div {
    max-width: 100%;

    width: 172px !important;
  }
`;

export const ContainerTextArea = styled.div``;
